/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  remitterAccountViewAll,
  remitterAddNewLabel,
  remitterRemoveNewLabel,
  setRemitterToggle,
  resetRemitterToggle,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const RemitterAccountViewAll = ({
  id,
  remPan,
  type,
  propType,
  remAccount,
  flow,
  currentAccountDetails,
  remLabel,
  remName,
  remIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  cardsType,
  onCardNavigate,
  cardType,
  openBeneAssociate,
  setSelectedCardIds,
  remid,
  selectedCardIds,
  remType,
  remiAcoountId,
}) => {
  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();
  const filterRef = useRef(null);
  const lastElementRef = useRef();
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const [active, setActive] = useState("");
  const [labels, setLabels] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputData, setInputData] = useState([]);
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");
  const { toggle } = useSelector((state) => state.remitterAccount);

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    toggle
      ? GlobalConfiguration.remitterAccountListCardHeight
      : GlobalConfiguration.remitterAcountGridCardHeight,
  );

  const [loadingData, setLoadingData] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState(
    selectedCardIds || [],
  );
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams(
      location?.state &&
        location?.state?.approvalStatus &&
        location?.state?.approvalStatus !== "all"
        ? {
            status: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");

  const [accountType, setAccountType] = useState(
    type === "RemitterAcc" ? "" : searchParam.get("accountType") || "",
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [searchUserText, setSearchUserText] = useState(
    remName || searchParam.get("search") || "",
  );

  const [LabelSearchText, setLabelSearchText] = useState(
    remLabel?.split(",") || searchParam.get("label")?.split(",") || [],
  );
  const [startDateFilter, setStartDateFilter] = useState(
    type === "RemitterAcc"
      ? ""
      : convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "RemitterAcc"
      ? ""
      : convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "RemitterAcc"
      ? ""
      : searchParam.get("status") ||
          (location?.state?.approvalStatus === "approved"
            ? "approved"
            : location?.state?.approvalStatus === "pending"
              ? "pending"
              : ""),
  );

  const { services } = useSelector((state) => state.refreshToken);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { showRestrictedAction } = useRestrictedAction();

  const filteredData = accumulatedData;
  const selectableAccounts = accumulatedData?.map((item) => ({
    ...item,
    id: item?.id,
  }));

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => itm.includes(searchUserTextDebounce))
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  async function fetchViewAllData() {
    setLoading(true);
    try {
      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        setLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        sort_by:
          accountbalancestate === "Name : A to Z"
            ? "ascending"
            : accountbalancestate === "Name : Z to A"
              ? "descending"
              : accountbalancestate === "Date : New to old"
                ? "latest"
                : accountbalancestate === "Date : Old to new"
                  ? "oldest"
                  : "latest",
        remitter_account_id: remType === "remitterMatch" ? [] : remid,
      };

      const addParamsBasedOnSelection = () => {
        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== 0) {
          queryParams.labels = LabelSearchText;
        }
        if (currentStatus !== "") {
          queryParams.approval_status =
            currentStatus === "require approval" ? "pending" : currentStatus;
        }
        if (accountType !== "") {
          queryParams.account_type = accountType;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(remitterAccountViewAll(queryParams));
      const newData = response?.payload?.remitter_accounts || [];
      setMainData(response?.payload);

      setAccumulatedData(newData);

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckOne,
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const totalRecordCount = Number(
    mainData?.total_count || GlobalConfiguration.lengthCheckZero,
  );

  const effectiveSelectCap =
    totalRecordCount > GlobalConfiguration.lengthCheckZero &&
    totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    LabelAccounts?.length === effectiveSelectCap &&
    effectiveSelectCap > GlobalConfiguration.lengthCheckZero;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableAccounts,
    );
  };

  const handleLabelAccountSelect = (account) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...account,
      id: account?.id,
    });
  };

  const isAccountSelected = (accountId) =>
    Array.isArray(LabelAccounts) &&
    LabelAccounts.some((acc) => (acc?.id ?? acc) === accountId);

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      fetchViewAllData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleSubmit = (key, value) => {
    if (type !== "RemitterAcc") {
      handleSearchParams(key, value);
    }
  };

  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.id,
      data?.category,
      data?.pan_no,
      data?.labels,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.bank_account_holder_full_name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });

      if (!showSearchBar) {
        dispatch(setRemitterToggle(newToggleValue));
      }
    }
  };

  const handleSelect = (value) => {
    setDirection("");
    handleSubmit("pagesize", value);

    if (isLabelClicked && LabelAccounts?.length > Number(value)) {
      handleChange(LabelAccounts, setLabelAccounts, value, LabelAccounts);
    }

    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback(() => {
    setIsWheelScrolling(true);
  }, []);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus) ||
        accountType !== "",
    );
  };

  const handlePagination = (page) => {
    setDirection("");
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleClearFilters = () => {
    handleClearSearchParam();
    setCurrentStatus("");
    setAccountType("");
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    if (
      propType === "ownerStatement" ||
      propType === "remitterDetails" ||
      !(type === "RemitterAcc" && searchUserText?.length && remName !== "")
    ) {
      setSearchUserText("");
    }
    if (
      propType === "ownerStatement" ||
      propType === "similerAccount" ||
      (type !== "RemitterAcc" && remLabel)
    ) {
      setLabelSearchText([]);
    }
    handleClearSearchParam();
    setisLabelClicked(false);
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    setSearchUserTextDebounce("");
    setaccountbalancestate("");
    handleClearSearchParam();
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      remitterAddNewLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (remitterAddNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterAddNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLoading(false);
    if (remitterAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);
    const res = await dispatch(
      remitterRemoveNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (remitterRemoveNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterRemoveNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
    }

    setLoading(false);
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(resetRemitterToggle(false));
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    fetchViewAllData();
    let availableLabels = sessionStorage?.getItem(
      "remitterAccountAvailableLabels",
    );
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentStatus,
    accountType,
    currentPage,
    searchUserText,
    pageSize,
    LabelSearchText,
    accountbalancestate,
    startDateFilter,
    endDateFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter, currentStatus, accountType]);

  useEffect(() => {
    if (filterRef.current) {
      filterRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [toggle, currentPage, accumulatedData]);

  return (
    <>
      <div
        className={`bg-primary-bg relative flex flex-col ${type === "RemitterAcc" ? "h-full" : "h-screen"}`}
        style={{
          position: type === "RemitterAcc" ? "" : "relative",
          overflow: "hidden",
          width: type === "RemitterAcc" ? "" : "var(--full-width)",
        }}
      >
        <div
          className={`${type === "RemitterAcc" ? " absolute" : "fixed"} ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} bg-primary-nav shadow-box-shadow-top bottom-bottom-base w-full rounded-none`}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero &&
            !loading && (
              <>
                <div
                  className={`${
                    showInnerSearchBar && "pointer-events-none h-full"
                  }`}
                >
                  {showInnerSearchBar && (
                    <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={PaginationConfiguration.paginationOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign Labels"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData?.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => isAccountSelected(account?.id))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={`relative z-z-index-overlay bg-primary-nav  ${type === "RemitterAcc" ? "hidden" : "block"}`}
        >
          <div>
            <div
              className={`hidden Qmd:block h-navbar-breadcrumb-height w-full`}
            ></div>
          </div>
        </div>

        <div className="bg-primary-nav flex flex-col items-center justify-center Qmd:shadow-box-shadow-bottom z-z-index-dropdown w-full relative">
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            handleBack={
              type === "RemitterAcc"
                ? undefined
                : () => {
                    navigate(-1);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These will be used to generate statistics for the associated remitter accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`Accounts selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: `Select up to ${Number(selectedValue)}`,
                    btnType: "button",
                    enabledBgColor: isAllSelected
                      ? "var(--positive-bg)"
                      : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: isLabelClicked ? false : true,
                    hoverOption:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "black"
                        : "white",

                    icon:
                      !loading && isAllSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (flow === "create" || type === "RemitterAcc") {
                        actionRestricted();
                        return;
                      }
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      loading ||
                      showSearchBar ||
                      flow === "create" ||
                      type === "RemitterAcc",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated remitter accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search remitter account",
              filterPlaceholder: "Name",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled:
                    propType === "ownerStatement" ||
                    propType === "remitterDetails"
                      ? false
                      : loading ||
                        (type === "RemitterAcc" && searchUserText?.length),
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled:
                    propType === "ownerStatement" ||
                    propType === "similerAccount"
                      ? false
                      : loading ||
                        (type === "RemitterAcc" &&
                          LabelSearchText?.length &&
                          remLabel !== ""),
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisable: false,
                  options:
                    services?.includes("REUAccount") &&
                    !services?.includes("REAAccount")
                      ? ["approved", "pending", "rejected", "archived"]
                      : [
                          "approved",
                          "require approval",
                          // "pending",
                          "rejected",
                          "archived",
                        ],
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(date);
                  },
                },
                {
                  name: "Account state",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: accountType,
                  dropdownPlaceHolder: "Select type",
                  isDisable: false,
                  options: ["New", "Edited"],
                  statusPop: true,
                  handleChange: (type) => {
                    handleSubmit("accountType", type);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountType(type);
                  },
                },
              ],
              sortByFilter: [
                {
                  name: "Date : New to old",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Date : Old to new",
                  isDisabled: false,
                },
                {
                  name: "Name : A to Z",
                  isDisabled: false,
                },
                {
                  name: "Name : Z to A",
                  isDisabled: false,
                },
              ],
              isSortDefaultDisabled:
                accountbalancestate === "" ||
                accountbalancestate === "latest" ||
                loading,
              sortValue: accountbalancestate,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setaccountbalancestate(val);
              },
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                accountType !== ""
              ),
              isSearchClearAllDisabled:
                propType === "ownerStatement"
                  ? false
                  : propType === "similerAccount" && remName
                    ? searchUserText === remName && !LabelSearchText?.length
                    : propType === "remitterDetails" && remLabel
                      ? LabelSearchText?.join(",") === remLabel &&
                        !searchUserText?.length
                      : type === "RemitterAcc" && remLabel
                        ? LabelSearchText?.join(",") === remLabel
                        : !(
                            LabelSearchText?.length ||
                            searchUserText?.length ||
                            loading
                          ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowSortBy: true,
              isSortDisabled: loading,
              isFilterDisabled: loading,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>

        {!toggle ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`z-z-index-content overflow-y-auto ${showInnerSearchBar ? "pointer-events-none" : ""} ${isLabelClicked && " pb-padding-xl mb-margin-xl Qsmd:pb-padding-base  Qsmd:mb-margin-base"}  infinityScrollContainerAccBeneView h-height-full flex-1
            `}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();
                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                onScroll={handleScroll}
                className={`scroll flex flex-col items-center h-full-height overflow-y-auto scroll-py-top_md ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full ${isLabelClicked ? "mt-margin-sm pt-padding-base" : ""} `}
                ref={filterRef}
              >
                <div
                  className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md`}
                >
                  {accumulatedData?.map((account) => (
                    <>
                      <CardContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        }
                        context={account}
                        isSelected={
                          propType === "similerAccount"
                            ? false
                            : id === account?.id
                              ? true
                              : remid?.includes(account?.id) &&
                                  remType === "remitterMatch"
                                ? true
                                : selectedCardIds?.includes(account?.id)
                                  ? true
                                  : cardType === "matchRemAcc"
                                    ? selectedAccounts.includes(account.id)
                                    : isAccountSelected(account.id)
                                      ? true
                                      : false
                        }
                        isDisabled={
                          propType === "similerAccount" && id === account?.id
                            ? true
                            : remid?.includes(account?.id) &&
                                remiAcoountId !== account?.id &&
                                remType === "remitterMatch"
                              ? true
                              : cardType === "matchRemAcc"
                                ? ["blocked", "archived", "rejected"].includes(
                                    account?.approval_status,
                                  )
                                : false
                        }
                        onClickHandler={(e, data) => {
                          if (flow === "create") {
                            handleDataPopup(data);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;

                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${account.id}`,
                                );
                                return;
                              } else if (cardType === "matchRemAcc") {
                                if (
                                  account.id === id ||
                                  (remid?.includes(account?.id) &&
                                    remType === "remitterMatch")
                                ) {
                                  CommonToast({
                                    text: "Originating account cannot be deselected.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                setSelectedAccounts((prev) => {
                                  const updated = prev.includes(account.id)
                                    ? prev.filter((sid) => sid !== account.id)
                                    : [...prev, account.id];

                                  const lockedIds = Array.isArray(id)
                                    ? id.filter(Boolean)
                                    : id
                                      ? [id]
                                      : [];

                                  setSelectedCardIds([
                                    ...new Set([...lockedIds, ...updated]),
                                  ]);

                                  return updated;
                                });

                                return;
                              } else {
                                navigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${account.id}`,
                                  {
                                    replace: openBeneAssociate ? true : false,
                                  },
                                );
                              }
                            } else {
                              handleLabelAccountSelect(account);
                            }
                          }
                        }}
                      >
                        <card-body>
                          {/* Account name row with optional selection icon */}
                          <TextWithIcon
                            type={"text"}
                            text={account.name}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(isLabelClicked ||
                              (cardType === "matchRemAcc" &&
                                id !== account?.id &&
                                account.approval_status !== "rejected" &&
                                account.approval_status !== "archived" &&
                                !(
                                  remType === "remitterMatch" &&
                                  remid?.includes(account?.id)
                                ))
                                ? [
                                    {
                                      icon:
                                        selectedCardIds?.includes(
                                          account?.id,
                                        ) ||
                                        selectedAccounts?.includes(
                                          account?.id,
                                        ) ||
                                        remiAcoountId?.includes(account?.id) ||
                                        isAccountSelected(account?.id)
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          {/* Account status */}
                          <TextWithIcon
                            text={
                              services?.includes("REAAccount") &&
                              account?.approval_status === "pending"
                                ? "Require approval"
                                : account?.approval_status
                            }

                            subText={"Account status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(account?.approval_status)}
                          />

                          {/* Labels */}
                          <TextWithIcon
                            text={account?.labels?.join(", ") || "Not assigned"}
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-body>
                      </CardContainer>
                    </>
                  ))}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full "
                style={{
                  height: showSearchBar ? " var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                  PointerEvent: showSearchBar && "none",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p className=" text-font-sm text-text-primary items-center font-normal mb-margin-sm">
                  No data found.
                </p>
                {(searchUserText !== "" ||
                  LabelSearchText?.length > 0 ||
                  isFilterApplied) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearFilters();
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            <div ref={lastElementRef}></div>
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            className={`flex-1 overflow-hidden scroll-py-top_md relative ${showInnerSearchBar ? " pointer-events-none" : ""} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();
                return false;
              }
              event.stopPropagation();
            }}
          >
            {showInnerSearchBar && (
              <div class="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className={`scroll flex flex-col items-center h-full overflow-y-auto scroll-py-top_md ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full ${isLabelClicked && "mt-margin-sm pt-padding-base pb-padding-xl mb-margin-xl Qsmd:pb-padding-base  Qsmd:mb-margin-base"}`}
                  ref={filterRef}
                  onScroll={handleScroll}
                >
                  <div className="standard-list-view-alignment !pt-padding-md">
                    {accumulatedData.map((item) => (
                      <ListContainer
                        filterRef={scrollContainerRef}
                        // hoverHeight={
                        //   GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        // }
                        key={item.id}
                        onClickHandler={(e, data) => {
                          if (flow === "create") {
                            handleDataPopup(data);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;

                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${item.id}`,
                                );
                                return;
                              } else if (cardType === "matchRemAcc") {
                                if (
                                  item.id === id ||
                                  (remid?.includes(item?.id) &&
                                    remType === "remitterMatch")
                                ) {
                                  CommonToast({
                                    text: "Originating account cannot be deselected.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                setSelectedAccounts((prev) => {
                                  const updated = prev.includes(item.id)
                                    ? prev.filter((sid) => sid !== item.id)
                                    : [...prev, item.id];

                                  const lockedIds = Array.isArray(id)
                                    ? id.filter(Boolean)
                                    : id
                                      ? [id]
                                      : [];

                                  setSelectedCardIds([
                                    ...new Set([...lockedIds, ...updated]),
                                  ]);

                                  return updated;
                                });

                                return;
                              } else {
                                navigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${item.id}`,
                                  {
                                    replace: openBeneAssociate ? true : false,
                                  },
                                );
                              }
                            } else {
                              handleLabelAccountSelect(item);
                            }
                          }
                        }}
                        isSelected={
                          propType === "similerAccount"
                            ? false
                            : id === item?.id
                              ? true
                              : remid?.includes(item?.id) &&
                                  remType === "remitterMatch"
                                ? true
                                : selectedCardIds?.includes(item?.id)
                                  ? true
                                  : cardType === "matchRemAcc"
                                    ? selectedAccounts.includes(item.id)
                                    : isAccountSelected(item.id)
                                      ? true
                                      : false
                        }
                        isDisabled={
                          propType === "similerAccount" && id === item?.id
                            ? true
                            : remid?.includes(item?.id) &&
                                remiAcoountId !== item?.id &&
                                remType === "remitterMatch"
                              ? true
                              : cardType === "matchRemAcc"
                                ? ["blocked", "archived", "rejected"].includes(
                                    item?.approval_status,
                                  )
                                : false
                        }
                        context={item}
                      >
                        <list-body>
                          <div className="w-full flex justify-between gap-x-gap-sm pt-padding-sm">
                            <div className="flex flex-col w-full">
                              <div className="w-full flex gap-x-gap-sm pr-padding-sm">
                                <p className="text-font-xs pl-padding-sm text-text-primary flex-1 truncate font-normal">
                                  <TickerAnimation text={item?.name} />
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p
                                    style={{
                                      color: getStatusColor(
                                        item?.approval_status,
                                      ),
                                    }}
                                    className="text-font-xs font-semibold capitalize min-w-standard-approval-status-min-width text-right"
                                  >
                                    {services?.includes("REAAccount") &&
                                    item?.approval_status === "pending"
                                      ? "Require approval"
                                      : item?.approval_status}
                                  </p>

                                  <img
                                    style={{
                                      display:
                                        isLabelClicked ||
                                        (cardType === "matchRemAcc" &&
                                          id !== item?.id)
                                          ? "flex"
                                          : "none",
                                    }}
                                    className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                    src={
                                      isLabelClicked ||
                                      (cardType === "matchRemAcc" &&
                                        id !== item?.id &&
                                        item.approval_status !== "rejected" &&
                                        item.approval_status !== "archived" &&
                                        !(
                                          remType === "remitterMatch" &&
                                          remid?.includes(item?.id)
                                        ))
                                        ? [
                                            // {

                                            selectedCardIds?.includes(
                                              item?.id,
                                            ) ||
                                            selectedAccounts?.includes(
                                              item?.id,
                                            ) ||
                                            remiAcoountId?.includes(item?.id) ||
                                            isAccountSelected(item?.id)
                                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                              : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                            // isDisabled: false,
                                            // },
                                          ]
                                        : []
                                    }
                                    alt=""
                                  />
                                </div>
                              </div>

                              <ListTextWithIcon
                                text={
                                  item?.labels?.join(", ") || "Not assigned"
                                }
                                iconComponentArray={[
                                  {
                                    icon: ICONS?.LABEL,
                                  },
                                ]}
                                fontWeight={"normal"}
                                textColor={"var(--text-primary)"}
                              />
                            </div>
                          </div>
                        </list-body>
                      </ListContainer>
                    ))}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height: showSearchBar ? "var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p className="bene-acc-no-beneaccount-text mb-margin-sm">
                  No data found.
                </p>
                {(searchUserText !== "" ||
                  LabelSearchText?.length > 0 ||
                  isFilterApplied) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearFilters();
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            <div ref={lastElementRef}></div>
          </div>
        )}

        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
          filteredData?.length > GlobalConfiguration.lengthCheckZero &&
          !loading && <div className="h-pagination-height flex-shrink-0"></div>}
      </div>
    </>
  );
};

export default RemitterAccountViewAll;
